"use strict"

import React from "react"
import ReactNative from "react-native"
import RomanNumerals from "roman-numerals"
import { toReadableFraction } from "readable-fractions"
import Device from "app/lib/Device"
import { connect } from "react-redux"
import config from "app/config"
import truncate from "truncate"
import Loading from "app/components/Loading"
import PostType from "app/models/PostType"
import SmallFeedPost from "app/components/SmallFeedPost"
import { formatDate } from "app/lib/utils/date"
import FS from "app/components/FS"
import LoadingOverlay from "app/components/LoadingOverlay"
import ChallengeSelector from "app/components/ChallengeSelector"
import ChallengeSubscriptionProgressBar from "app/components/ChallengeSubscriptionProgressBar"
import ChallengeCheckinLog from "app/components/ChallengeCheckinLog"
import ChallengeLevelSelector from "app/components/ChallengeSelector/components/ChallengeLevelSelector"
import ChallengePausedOverlay from "app/components/ChallengePausedOverlay"
import Color from "color"
import { colors } from "app/lib/styles"

import SubscriptionConcludedExperience from "./components/SubscriptionConcludedExperience"
import ChallengeOnboarding from "./components/ChallengeOnboarding"

import { activatePost } from "app/actions/newPost/"
import { navigateTo } from "app/actions/app"

import {
  concludeChallengeSubscription,
  getLatestSubscription,
  getActiveSubscriberCounts,
  getSuggestedPosts,
  toggleGuide,
  toggleInviteFriends,
  updateChallengeSubscription,
  changeLevelTab,
  getLevelStats,
} from "app/actions/challenges"

import { setChallengeGroups, executeSearch } from "app/actions/search"

import { switchTab } from "app/actions/app"

const {
  View,
  StatusBar,
  StyleSheet,
  InteractionManager,
  Platform,
  SafeAreaView,
} = ReactNative

class MyChallenge extends FS.View {
  state = {
    challengeLevelInfoShowing: null,
  }

  getMyUrl() {
    return "mychallenge"
  }

  get sub() {
    let sub = null
    if (this.props.challenges.latestChallengeSubscriptionId) {
      sub = dataStore.get(
        "challenge_subscription",
        this.props.challenges.latestChallengeSubscriptionId
      )
    }
    return sub
  }

  get levelModalVisible() {
    var level = this.props.challenges.activeTabLevel
    var completed = false
    if (this.props.challenges.maxChallengeDifficultiesAchieved) {
      completed =
        level <=
        this.props.challenges.maxChallengeDifficultiesAchieved[this.sub.challenge_id]
    }
    return level && !completed && level !== this.sub.challenge_difficulty.difficulty_level
  }

  handleDoneForDayPress = () => {
    this.props.dispatch(concludeChallengeSubscription())
  }

  handleProgressTabPress = difficultyLevel => {
    this.props.dispatch(changeLevelTab(difficultyLevel))
    setTimeout(() => {
      if (
        !this.levelModalVisible &&
        difficultyLevel !== this.sub.challenge_difficulty.difficulty_level
      ) {
        this.props.dispatch(getLevelStats(this.sub.challenge_id, difficultyLevel))
      }
    }, 10)
  }

  handleLevelInfoClose = () => {
    this.props.dispatch(changeLevelTab(null))
  }

  handleTipPress(tip) {
    if (tip.post_id) {
      this.props.dispatch(
        navigateTo(
          "post",
          {
            title: truncate(tip.tip, 20),
            postId: tip.post_id,
          },
          "mychallenge"
        )
      )
    }
  }

  initializeTabContent = () => {
    InteractionManager.runAfterInteractions(() => {
      if (!this.props.challenges.latestSubscriptionInitialized) {
        this.props.dispatch(getLatestSubscription())
      }
      if (
        !this.props.challenges.activeSubscriberCounts &&
        !this.props.challenges.fetchingActiveSubscriberCounts
      ) {
        this.props.dispatch(getActiveSubscriberCounts())
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.app.initializedTabs.mychallenge &&
      nextProps.challenges.latestChallengeSubscriptionId &&
      !nextProps.challenges.suggestedPostIdsForLatestSubscriptionInitialized
    ) {
      this.props.dispatch(
        getSuggestedPosts(nextProps.challenges.latestChallengeSubscriptionId)
      )
    }
  }

  renderChallengeSelector() {
    return (
      <View style={styles.container}>
        <StatusBar backgroundColor={colors.lightGray} />
        <View style={styles.statusBarBG} />
        <FS.ScrollView style={styles.container}>
          <View style={styles.selectorInfo}>
            <FS.Text style={styles.selectorHeading}>Select a New Challenge:</FS.Text>
          </View>
          <View style={styles.selectorWrap}>
            <ChallengeSelector />
          </View>
        </FS.ScrollView>
      </View>
    )
  }

  renderProgressTab(diff, sub) {
    var current = diff.id === this.sub.challenge_difficulty_id
    var active = this.props.challenges.activeTabLevel
      ? diff.difficulty_level === this.props.challenges.activeTabLevel
      : current
    var completed = false
    if (this.props.challenges.maxChallengeDifficultiesAchieved) {
      completed =
        diff.difficulty_level <=
        this.props.challenges.maxChallengeDifficultiesAchieved[this.sub.challenge_id]
    }

    return (
      <FS.Touchable
        style={[styles.progressTab, active ? styles.progressTabActive : null]}
        key={diff.id}
        onPress={() => this.handleProgressTabPress(diff.difficulty_level)}
      >
        {!current ? (
          <FS.Icon
            name={completed ? "checkmark" : "lock-filled"}
            style={[styles.progressTabIcon, active ? styles.progressTabIconActive : null]}
          />
        ) : null}
        <FS.Text
          style={[styles.progressTabLabel, active ? styles.progressTabActiveLabel : null]}
        >
          {RomanNumerals.toRoman(diff.difficulty_level)}
        </FS.Text>
      </FS.Touchable>
    )
  }

  renderLevelTabContent(sub) {
    if (
      !this.props.challenges.activeTabLevel ||
      this.props.challenges.activeTabLevel === sub.challenge_difficulty.difficulty_level
    ) {
      return this.renderProgressBar(sub)
    } else {
      return this.renderStats(sub)
    }
  }

  renderProgressBar(sub) {
    var duration = sub.challenge_difficulty.duration_days
    var headingText =
      duration > 1
        ? `You're on day ${sub.current_day} of ${duration}`
        : "Just 1 day to go"
    if (!sub.hasStarted) {
      headingText = "Level Starts Tomorrow!"
    }
    if (
      sub.current_day === duration &&
      sub.day_progress[sub.current_day - 1] &&
      sub.day_progress[sub.current_day - 1].has_checkin
    ) {
      headingText = "Keep it up for the rest of the day!"
    }

    return (
      <View>
        <View style={styles.contentContainerHeader}>
          <FS.Text style={styles.contentContainerHeaderLabel}>{headingText}</FS.Text>
        </View>
        <ChallengeSubscriptionProgressBar subscription={sub} style={styles.progressBar} />
      </View>
    )
  }

  renderStats(sub) {
    var stats = this.props.challenges.levelStats[sub.challenge_id]
    stats = stats ? stats[this.props.challenges.activeTabLevel] : null
    if (stats) {
      return (
        <View style={styles.levelStatsWrap}>
          <View style={styles.levelStatsRow}>
            <FS.Text style={styles.levelStatsLabel}># Days:</FS.Text>
            <FS.Text style={styles.levelStatsValue}>{stats.day_count}</FS.Text>
          </View>
          <View style={styles.levelStatsRow}>
            <FS.Text style={styles.levelStatsLabel}># Check-ins:</FS.Text>
            <FS.Text style={styles.levelStatsValue}>{stats.success_count}</FS.Text>
          </View>
          <View style={styles.levelStatsRow}>
            <FS.Text style={styles.levelStatsLabel}># Passes Used:</FS.Text>
            <FS.Text style={styles.levelStatsValue}>
              {stats.slip_count ? toReadableFraction(stats.slip_count, true) : 0}
            </FS.Text>
          </View>
          {stats.last_concluded_at ? (
            <View style={styles.levelStatsRow}>
              <FS.Text style={styles.levelStatsLabel}>Completed:</FS.Text>
              <FS.Text style={styles.levelStatsValue}>
                {formatDate(stats.last_concluded_at, "datetime", null, "ddd, MMM Do")}
              </FS.Text>
            </View>
          ) : null}
        </View>
      )
    } else if (this.props.challenges.fetchingLevelStats) {
      return (
        <View style={styles.levelStatsWrap}>
          <Loading style={styles.levelStatsLoading} />
        </View>
      )
    }
  }

  renderProgress(sub) {
    var difficulties = sub.challenge.challenge_difficulties.sort(
      (a, b) => a.difficulty_level - b.difficulty_level
    )
    return (
      <View>
        <View style={styles.progressTabs}>
          {difficulties.map(diff => this.renderProgressTab(diff, sub))}
        </View>
        <View style={[styles.contentContainer, styles.progressContentContainer]}>
          {this.renderLevelTabContent(sub)}
        </View>
      </View>
    )
  }

  renderTip(sub) {
    var tip = sub.challenge_tip
    if (tip) {
      var Component = tip.post_id ? FS.Touchable : View
      return (
        <Component style={styles.tipWrap} onPress={() => this.handleTipPress(tip)}>
          <FS.Icon name="type-tip" style={styles.tipIcon} />
          <View style={styles.tipText}>
            <FS.Text style={styles.tipHeading} allowFontScaling={true} numberOfLines={1}>
              Today's Tip
            </FS.Text>
            <FS.Text style={styles.tipTip} allowFontScaling={true} numberOfLines={5}>
              {tip.tip}
            </FS.Text>
          </View>
          {tip.post_id ? <FS.Icon name="right-arrow" style={styles.tipArrow} /> : null}
        </Component>
      )
    }
  }

  renderSuggestedPosts(sub) {
    if (
      this.props.challenges.fetchingSuggestedPostsForLatestSubscription ||
      this.props.challenges.suggestedPostIdsForLatestSubscription ||
      !this.props.suggestedPostIdsForLatestSubscriptionInitialized
    ) {
      var counts = this.props.challenges.activeSubscriberCounts
      var count = counts && counts[sub.challenge_id] ? counts[sub.challenge_id] - 1 : 0
      var countText = count ? `+ ${count} others doing this challenge` : ""
      var posts = dataStore.getMany(
        "post",
        this.props.challenges.suggestedPostIdsForLatestSubscription || []
      )

      return (
        <View style={styles.suggestedWrapper}>
          <FS.Text style={styles.suggestedHeading}>
            Suggested Posts from the Community
          </FS.Text>
          <FS.Text style={styles.suggestedCountInfo}>{countText}</FS.Text>

          <View style={styles.moreButtonsWrapTop}>
            <FS.Touchable style={styles.moreButton} onPress={this.handleAskQuestionPress}>
              <FS.Text style={styles.moreButtonLabel}>Ask A Question</FS.Text>
            </FS.Touchable>
          </View>

          {this.props.challenges.fetchingSuggestedPostsForLatestSubscription ? (
            <Loading isLoading={true} style={styles.suggestedPostsLoading} />
          ) : posts && posts.length > 0 ? (
            <View style={styles.suggestedPostsList}>
              {posts.map(post => <SmallFeedPost key={post.id} postId={post.id} />)}
            </View>
          ) : (
            <View style={styles.suggestedPostsUnavailableWrap}>
              <FS.Text style={styles.suggestedPostsUnavailableText}>
                Nothing to see right now, check back later
              </FS.Text>
            </View>
          )}
        </View>
      )
    }
  }

  handleBuddiesPress = () => {
    this.props.dispatch(switchTab("buddies"))
  }

  handleCheckInPress = () => {
    this.props.dispatch(switchTab("checkin"))
  }

  handleAskQuestionPress = () => {
    this.props.dispatch(
      activatePost({
        post_type_ids: [PostType.getIdForName("Question")],
        challenge_group_ids: [this.sub.challenge.challenge_group_id],
      })
    )
  }

  handleSeeMorePostsPress = () => {
    this.props.dispatch(switchTab("feed"))
    this.props.dispatch(setChallengeGroups([this.sub.challenge.challenge_group_id]))
    this.props.dispatch(executeSearch(""))
  }

  handleChallengeSettingsPress = () => {
    this.props.dispatch(
      navigateTo("challenge_settings", {
        title: "Challenge Settings",
        challenge: this.sub.challenge,
      })
    )
  }

  handleGuidePress = () => {
    this.props.dispatch(toggleGuide())
  }

  renderMainButton(iconName, label, onPressAction) {
    return (
      <FS.Touchable
        style={[
          styles.mainButton,
          iconName === "guide" ? styles.mainButtonLeft : styles.mainButtonRight,
          onPressAction ? null : styles.mainButtonDisabled,
        ]}
        onPress={onPressAction}
      >
        <View style={styles.mainButtonIconWrap}>
          <FS.Icon
            name={iconName}
            style={[
              styles.mainButtonIcon,
              onPressAction ? null : styles.mainButtonIconDisabled,
            ]}
          />
        </View>
        <FS.Text style={styles.mainButtonLabel} allowFontScaling={false}>
          {label}
        </FS.Text>
      </FS.Touchable>
    )
  }

  renderLog(sub) {
    if (sub && sub.checkins.length > 0) {
      return (
        <View style={styles.logWrap}>
          <FS.Text style={styles.logTitle}>Check-in History</FS.Text>
          <ChallengeCheckinLog
            subscriptionIds={[sub.id]}
            dispatch={this.props.dispatch}
          />
        </View>
      )
    }
  }

  renderDoneForDay(sub) {
    if (
      sub &&
      sub.active &&
      sub.current_day >= sub.challenge_difficulty.duration_days &&
      sub.day_progress[sub.day_progress.length - 1].has_checkin
    ) {
      return (
        <FS.Touchable
          onPress={this.handleDoneForDayPress}
          style={styles.doneForDayButton}
        >
          <FS.Icon name="thumbs-up" style={styles.doneForDayIcon} />
          <FS.Text style={styles.doneForDayButtonText}>Complete my day</FS.Text>
        </FS.Touchable>
      )
    }
  }

  renderLevelInfo(sub) {
    var visible = this.levelModalVisible

    return (
      <FS.Modal
        animation="slideInUp"
        closeAnimation="slideOutDown"
        duration={250}
        visible={visible}
      >
        {visible ? (
          <ChallengeLevelSelector
            challenge={sub.challenge}
            difficultyLevel={this.props.challenges.activeTabLevel}
            activeLevelOnly={true}
            informationOnly={true}
            navigation={this.props.navigation}
            onBack={this.handleLevelInfoClose}
          />
        ) : null}
      </FS.Modal>
    )
  }

  renderCurrentChallenge(sub) {
    return (
      <View style={styles.container}>
        <StatusBar backgroundColor={colors.challengeOrange} />
        <View style={styles.statusBarBG} />
        <View style={styles.fixedHeader}>
          {sub.challenge_difficulty ? (
            <FS.Text style={styles.headerLevel} numberOfLines={1}>
              {sub.challenge_difficulty.displayName}
            </FS.Text>
          ) : null}
          <FS.Touchable
            style={styles.headerSettingsIconWrap}
            onPress={this.handleChallengeSettingsPress}
          >
            <FS.Icon name="settings" style={styles.headerSettingsIcon} />
          </FS.Touchable>
        </View>
        <FS.ScrollView style={styles.container} ref={c => (this._contentRef = c)}>
          <View style={styles.header}>
            <FS.Text style={styles.headerTitle} numberOfLines={3}>
              {sub.challenge.name}
            </FS.Text>
          </View>

          <View style={styles.bodyContentWrap}>
            {this.renderProgress(sub)}
            {this.renderDoneForDay(sub)}

            <View style={styles.mainButtonsWrap}>
              {this.renderMainButton(
                "guide",
                "View Guide",
                sub && sub.challenge.guide_url ? this.handleGuidePress : null
              )}
              {this.renderMainButton("buddies", "Buddies", this.handleBuddiesPress)}
            </View>

            {this.renderTip(sub)}

            {this.renderSuggestedPosts(sub)}

            <View style={styles.moreButtonsWrapBottom}>
              <FS.Touchable
                style={styles.moreButton}
                onPress={this.handleSeeMorePostsPress}
              >
                <FS.Text style={styles.moreButtonLabel}>See More Posts</FS.Text>
              </FS.Touchable>
            </View>
          </View>

          {this.renderLog(sub)}
        </FS.ScrollView>

        <ChallengeOnboarding {...this.props} />
        {this.renderLevelInfo(sub)}
      </View>
    )
  }

  renderLoading() {
    return (
      <View style={styles.loadingContainer}>
        <Loading />
      </View>
    )
  }

  renderContents() {
    if (
      this.sub &&
      (this.sub.active ||
        (this.sub.succeeded !== null && this.props.challenges.subscriptionConcluded))
    ) {
      return this.renderCurrentChallenge(this.sub)
    } else if (
      !this.props.challenges.fetchingLatestSubscription &&
      this.props.deviceReachability.isReachable
    ) {
      return this.renderChallengeSelector()
    } else {
      return this.renderLoading()
    }
  }

  render() {
    return (
      <SafeAreaView style={styles.container}>
        {this.renderContents()}

        <LoadingOverlay
          isLoading={
            this.props.challenges.updatingSubscription ||
            this.props.challenges.subscribingToChallenge
          }
          style={{ top: -20 }}
        />
        <SubscriptionConcludedExperience {...this.props} />
        <ChallengePausedOverlay tintColor={colors.challengeOrange} />
      </SafeAreaView>
    )
  }
}

function mapStateToProps(state) {
  return Object.assign(
    {},
    {
      app: state.app,
      nav: state.nav,
      challenges: state.challenges,
      checkins: state.checkins,
      deviceReachability: state.deviceReachability,
    }
  )
}

export default connect(mapStateToProps)(MyChallenge)

var styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.challengeOrange,
  },
  loadingContainer: {
    flex: 1,
    backgroundColor: colors.challengeOrange,
    justifyContent: "center",
    alignItems: "center",
  },
  statusBarBG: {
    position: "absolute",
    width: Device.width,
    height: 20,
    top: -20,
    left: 0,
    backgroundColor: colors.challengeOrange,
  },
  fixedHeader: {
    backgroundColor: colors.challengeOrange,
    alignItems: "center",
    padding: 5,
    position: "relative",
  },
  header: {
    backgroundColor: colors.challengeOrange,
    alignItems: "center",
    padding: 2,
    paddingTop: -3,
    position: "relative",
  },
  headerTitle: {
    textAlign: "center",
    fontSize: 22,
    letterSpacing: -0.5,
    color: colors.white,
    marginHorizontal: 32,
    paddingBottom: 10,
  },
  headerLevel: {
    marginTop: 0,
    fontSize: 16,
    letterSpacing: -0.5,
    color: colors.white,
  },
  headerSettingsIconWrap: {
    position: "absolute",
    right: -4,
    top: -10,
  },
  headerSettingsIcon: {
    fontSize: 22,
    color: colors.white,
    padding: 12,
    backgroundColor: "transparent",
  },
  mainButtonsWrap: {
    flexDirection: "row",
    justifyContent: "space-around",
    marginBottom: 12,
  },
  mainButton: {
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    backgroundColor: colors.challengeOrange,
    paddingVertical: 8,
    marginHorizontal: 12,
    borderRadius: 4,
    flex: 1,
  },
  mainButtonLeft: {
    marginRight: 0,
  },
  mainButtonIconWrap: {
    marginLeft: 5,
    width: 30,
    height: 30,
    justifyContent: "center",
    alignItems: "center",
  },
  mainButtonIcon: {
    fontSize: 22,
    color: colors.black,
    opacity: 0.43,
  },
  mainButtonIconDisabled: {
    opacity: 0.4,
  },
  mainButtonLabel: {
    fontSize: 14,
    letterSpacing: -0.3,
    color: colors.white,
    textAlign: "center",
    marginHorizontal: 5,
    fontWeight: "500",
  },
  bodyContentWrap: {
    backgroundColor: colors.lightGray,
  },
  contentContainer: {
    backgroundColor: colors.white,
    padding: 20,
    paddingHorizontal: 8,
    borderRadius: 6,
    margin: 10,
  },
  contentContainerHeader: {
    marginTop: -20,
    marginHorizontal: -8,
    marginBottom: 2,
    padding: 10,
  },
  contentContainerHeaderLabel: {
    fontSize: 16,
    fontWeight: "600",
    letterSpacing: -0.3,
    color: colors.mediumGray,
    textAlign: "center",
  },
  suggestedWrapper: {
    alignItems: "center",
    paddingVertical: 20,
    paddingHorizontal: 10,
  },
  suggestedHeading: {
    textAlign: "center",
    fontSize: 16,
    letterSpacing: -0.4,
    color: colors.challengeOrange,
    fontWeight: "500",
  },
  suggestedCountInfo: {
    textAlign: "center",
    fontSize: 14,
    letterSpacing: -0.4,
    color: colors.gray,
    marginBottom: 15,
  },
  suggestedPostsList: {
    marginBottom: -20,
  },
  suggestedPostsLoading: {
    margin: 25,
  },
  suggestedPostsUnavailableWrap: {
    padding: 25,
  },
  suggestedPostsUnavailableText: {
    textAlign: "center",
  },
  moreButtonsWrapTop: {
    marginTop: 5,
    marginBottom: 20,
    flexDirection: "row",
    justifyContent: "space-around",
  },
  moreButtonsWrapBottom: {
    marginTop: 5,
    marginBottom: 20,
    flexDirection: "row",
    justifyContent: "space-around",
    marginHorizontal: 10,
  },
  moreButton: {
    flex: 1,
    backgroundColor: colors.white,
    padding: 15,
    paddingVertical: 8,
    borderRadius: 6,
  },
  moreButtonLabel: {
    fontSize: 16,
    letterSpacing: -0.4,
    fontWeight: "500",
    color: colors.darkGray,
    textAlign: "center",
  },
  selectorInfo: {
    padding: 10,
    paddingTop: 15,
    backgroundColor: colors.challengeOrange,
  },
  selectorHeading: {
    color: colors.white,
    textAlign: "center",
    fontSize: 18,
    fontWeight: "300",
    letterSpacing: -0.5,
  },
  selectorWrap: {
    padding: 10,
    backgroundColor: colors.lightGray,
  },
  progressBar: {
    marginHorizontal: 8,
  },
  logWrap: {
    backgroundColor: colors.white,
    paddingVertical: 30,
    paddingHorizontal: 10,
  },
  logTitle: {
    color: colors.challengeOrange,
    fontSize: 16,
    fontWeight: "600",
    letterSpacing: -0.4,
    textAlign: "center",
    marginBottom: 30,
  },
  tipWrap: {
    flexDirection: "row",
    marginHorizontal: 10,
    backgroundColor: colors.white,
    borderRadius: 6,
    alignItems: "center",
  },
  tipText: {
    flex: 1,
    padding: 15,
    paddingLeft: 12,
    paddingRight: 5,
  },
  tipHeading: {
    color: colors.challengeOrange,
    fontSize: 16,
    letterSpacing: -0.4,
    textAlign: "left",
    marginBottom: 5,
    fontWeight: "600",
  },
  tipTip: {
    color: colors.darkMediumAndSortaBlueishGray,
    fontSize: Device.width > 320 ? 16 : 15,
    letterSpacing: -0.4,
    lineHeight: Device.width > 320 ? 20 : 18,
    textAlign: "left",
  },
  tipIcon: {
    padding: 12,
    paddingRight: 0,
    color: colors.challengeOrange,
    fontSize: 42,
  },
  tipArrow: {
    padding: 10,
    color: colors.gray,
    fontSize: 15,
    opacity: 0.5,
  },
  progressContentContainer: {
    backgroundColor: colors.white,
    paddingTop: 30,
    paddingVertical: 20,
    paddingHorizontal: 8,
    borderRadius: 6,
    margin: 10,
    marginTop: 0,
  },
  progressTabs: {
    flexDirection: "row",
    margin: 10,
    marginBottom: -9,
  },
  progressTab: {
    flex: 1,
    padding: 9,
    paddingBottom: 18,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  progressTabActive: {
    backgroundColor: colors.white,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },
  progressTabIcon: {
    color: colors.mediumGray,
    opacity: 0.8,
    fontSize: 10,
    marginRight: 5,
  },
  progressTabIconActive: {
    color: colors.challengeOrange,
  },
  progressTabLabel: {
    color: colors.mediumGray,
    opacity: 0.8,
    fontSize: 18,
    fontWeight: "600",
  },
  progressTabActiveLabel: {
    color: colors.challengeOrange,
    fontSize: 22,
  },
  doneForDayButton: {
    flexDirection: "row",
    borderRadius: 6,
    marginBottom: 10,
    marginTop: -5,
    marginHorizontal: 10,
    alignItems: "center",
    justifyContent: "center",
    padding: 15,
    backgroundColor: colors.white,
  },
  doneForDayIcon: {
    fontSize: 18,
    color: colors.challengeOrange,
    marginRight: 5,
  },
  doneForDayButtonText: {
    fontSize: 15,
    fontWeight: "600",
    color: colors.challengeOrange,
  },
  levelStatsRow: {
    flexDirection: "row",
    marginVertical: 2,
    marginHorizontal: 15,
  },
  levelStatsLabel: {
    textAlign: "right",
    fontSize: 16,
    fontWeight: "500",
    color: colors.darkGray,
    marginRight: 12,
  },
  levelStatsValue: {
    flex: 1,
    width: 100,
    fontSize: 16,
    fontWeight: "600",
    textAlign: "left",
  },
})
